// `.js` so the mocha/ts-node ESM runner can resolve it from the test too.
import { placeholderCaption } from './downloadPlaceholder.js'

import type { T } from '@deltachat/jsonrpc-client'

/**
 * The text that "Copy Text" puts on the clipboard for a multi-message
 * selection: the message bodies, one per line, in the order given — pass the
 * ids in display order, not click order.
 *
 * Messages without text (stickers, bare images, files, webxdc) drop out
 * instead of getting a `[photo.jpg]` placeholder line: that is transcript
 * formatting, and this is the same action as the single-message "Copy Text".
 * Export Chat is where a dated, attributed transcript lives.
 */
export function formatMessagesForClipboard(
  messages: Array<T.MessageLoadResult | undefined>
): string {
  return messages
    .map(message => {
      if (message?.kind !== 'message') {
        return ''
      }
      // Not downloaded yet: copy what is on screen, i.e. the caption without
      // the "[Label – size]" tag core appends — same as single-message copy.
      return message.downloadState !== 'Done'
        ? placeholderCaption(message.text)
        : message.text
    })
    .filter(text => text !== '')
    .join('\n')
}
